// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","terms":"styles_terms__1fGPe","modal":"styles_modal__z+z3N"};